module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-p-500-36f52b4a9a1b9aea767f594c4ec44d1b.jpg";